// theme.js
import { createTheme } from '@mui/material/styles';

const b2bTheme = createTheme({
    typography: {
        fontFamily: 'Inter, sans-serif',
        h1: {
            fontFamily: 'Lexend, sans-serif',
        },
        h2: {
            fontFamily: 'Lexend, sans-serif',
        },
        h3: {
            fontFamily: 'Lexend, sans-serif',
        },
        h4: {
            fontFamily: 'Lexend, sans-serif',
        },
        h5: {
            fontFamily: 'Lexend, sans-serif',
        },
    },
    palette: {
        primary: {
            main: '#011d89',
        },
        secondary: {
            main: '#3233c1',
        },
        background: {
            default: '#ffffff', // White color
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#3233c1',
                    color: '#fbfbffea',
                    textTransform: 'none',
                    border: '1px solid #3233c1',
                    borderRadius: '28px',
                    padding: '0px 14px',
                    fontSize: '0.95rem',
                    '&:hover': {
                        backgroundColor: '#011d89',
                        color: '#fbfbffea',
                    },
                },
            },
        },
        MuiCartHeader: {
            styleOverrides: {
                root: {
                    backgroundColor: '#011d89',
                    color: '#ffffff',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: '#011d89',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                input: {
                    color: '#011d89',
                },
                underline: {
                    "&:before": {
                        borderColor: '#011d89', // when not inside
                    },
                    "&&:hover:not(.Mui-disabled):before": {
                        borderColor: '#3233c1', // on hover
                    },
                    "&:after": {
                        borderColor: '#3233c1', // on edit
                    },
                },
            },
        },
    },

});

export default b2bTheme;
